export default "__VITE_ASSET__Df1VHx7___"